import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import ButtonComponent from "../../../../../../app/common-components/ButtonComponent";
import CustomSelectDropDown from "../../../../../../app/common-components/CustomSelectDropDown";
import Input from "../../../../../../app/common-components/form/input";
import Spinners from "../../../../../../app/common-components/Spinner";
import {
  decrypt,
  useCommonAlert,
} from "../../../../../../app/utilities/helpers";
import {
  getConfigJiraIssueTypeList,
  getConfigJiraPriorityList,
  getConfigJiraStatusList,
  getJiraIssueTypeSave,
  getJiraPrioritySave,
  getJiraStatusSave,
} from "../../ToolsSlice";
import "./styles.css";
import {
  CATEGORY_TYPES,
  CATEGORY_TYPE_LOWERCASE,
  DISPLAY_LABELS,
} from "./Utilities/Identifiers";

const AddConfig = (props) => {
  const { jiraIssuetypeLoading, jiraPriorityLoading, jiraStatusLoading } =
    useSelector((state) => state.toolsApi);

  // Get the appropriate loading state based on active tab
  const _normalizedActiveTab = props?.activeTab?.toString()?.toLowerCase();
  const jiraLoading = _normalizedActiveTab?.includes(CATEGORY_TYPE_LOWERCASE.ISSUE)
    ? jiraIssuetypeLoading
    : _normalizedActiveTab?.includes(CATEGORY_TYPE_LOWERCASE.PRIORITY)
    ? jiraPriorityLoading
    : jiraStatusLoading;

  const dispatch = useDispatch();
  const [selectedOptionerrorMessage, setselectedOptionErrorMessage] =
    useState("");
  const [selectedOptionstate, setselectedOptionstate] = useState(false);
  const [CategorynameerrorMessage, setCategorynameErrorMessage] = useState("");
  const [Categorystate, setCategorystate] = useState(false);
  const [searchQuery1, setSearchQuery1] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");

  const apidata = props?.ApiData;

  // Map incoming activeTab or selected option keys to API keys (consistent casing)
  const mapToApiKey = (tab) => {
    if (!tab) {
      return null;
    }
    const t = tab.toString().toLowerCase();
    if (t.includes(CATEGORY_TYPE_LOWERCASE.ISSUE)) {
      return CATEGORY_TYPES.ISSUE_TYPE;
    }
    if (t.includes(CATEGORY_TYPE_LOWERCASE.PRIORITY)) {
      return CATEGORY_TYPES.PRIORITY;
    }
    if (t.includes(CATEGORY_TYPE_LOWERCASE.STATUS)) {
      return CATEGORY_TYPES.STATUS;
    }
    return tab;
  };

  const { common } = useSelector((state) => state);
  const { userName } = common.loggedUser;
  const encodeduserName = decrypt(userName);

  // Extracting options from API data (NEW STRUCTURE)
  const extractedOptions = useMemo(() => {
    if (!apidata) {
      return [];
    }
    const keys = [CATEGORY_TYPES.ISSUE_TYPE, CATEGORY_TYPES.PRIORITY, CATEGORY_TYPES.STATUS].filter((k) => apidata[k]);
    return keys.map((key) => {
      const data = apidata[key];
      // Find uncategorized items from the new array structure
      const uncategorizedData = Array.isArray(data)
        ? data.find((item) => item?.categoryName === CATEGORY_TYPES.UNCATEGORIZED)
        : null;

      // Extract items based on type
      let items = [];
      if (uncategorizedData) {
        if (key === CATEGORY_TYPES.ISSUE_TYPE) {
          items = uncategorizedData.issueTypes || [];
        } else if (key === CATEGORY_TYPES.PRIORITY) {
          items = uncategorizedData.priorityType || [];
        } else if (key === CATEGORY_TYPES.STATUS) {
          items = uncategorizedData.statusType || [];
        }
      }

      return {
        label: key === CATEGORY_TYPES.ISSUE_TYPE ? DISPLAY_LABELS.ISSUE_TYPE : key,
        value: items,
        originalKey: key,
      };
    });
  }, [apidata]);

  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const getDefaultOption = () => {
    if (!extractedOptions.length) {
      return null;
    }
    const apiKey =
      mapToApiKey(props?.activeTab) || extractedOptions[0]?.originalKey;
    const matchedOption = extractedOptions.find(
      (opt) => opt.originalKey === apiKey
    );
    return matchedOption || extractedOptions[0] || null;
  };

  // State for selected category
  const [selectedOption, setSelectedOption] = useState(getDefaultOption());
  const [sortOrder, setSortOrder] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);

  // Dynamic sort order options based on selected category
  const getSortOrderOptions = useMemo(() => {
    if (!selectedOption?.originalKey || !apidata) {
      return [];
    }
    const categoryKey = selectedOption.originalKey;
    const dataArray = apidata[categoryKey] || [];

    // Count existing categorized items (excluding Uncategorized)
    const categorizedCount = Array.isArray(dataArray)
      ? dataArray.filter((item) => item?.categoryName !== CATEGORY_TYPES.UNCATEGORIZED)
          .length
      : 0;

    // Generate options from 1 to categorizedCount + 1 (for new category)
    return Array.from({ length: categorizedCount + 1 }, (_, i) => ({
      label: (i + 1).toString(),
      value: i + 1,
    }));
  }, [selectedOption, apidata]);

  const [items1, setItems1] = useState([]);
  const [items2, setItems2] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [Categoryname, setCategoryname] = useState("");
  const [movedItems, setMovedItems] = useState([]);
  const [initialItems2, setInitialItems2] = useState([]);

  useEffect(() => {
    if (!selectedOption || !apidata) {
      return;
    }

    const categoryData = apidata[selectedOption.originalKey];

    // Find uncategorized data from new array structure
    const uncategorizedData = Array.isArray(categoryData)
      ? categoryData.find((item) => item?.categoryName === CATEGORY_TYPES.UNCATEGORIZED)
      : null;

    // Extract items based on type
    let uncategorizedItems = [];
    if (uncategorizedData) {
      let items = [];
      if (selectedOption.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
        items = uncategorizedData.issueTypes || [];
      } else if (selectedOption.originalKey === CATEGORY_TYPES.PRIORITY) {
        items = uncategorizedData.priorityType || [];
      } else if (selectedOption.originalKey === CATEGORY_TYPES.STATUS) {
        items = uncategorizedData.statusType || [];
      }

      uncategorizedItems = items.map((item, index) => ({
        id: `${selectedOption.originalKey}-${index}`,
        content: item,
      }));
    }

    setItems1(uncategorizedItems);
    setItems2([]);
    setSelectedItems([]);
    setCategoryName("");
    setCategoryname("");
    setSortOrder(null); // Reset sort order when selected option changes
  }, [selectedOption, apidata]);

  useEffect(() => {
    // Check if Group Name and Sorting Order are filled
    setIsFormValid(Categoryname.trim() !== "" && sortOrder !== null);
  }, [Categoryname, sortOrder]);

  useEffect(() => {
    setInitialItems2([...items2]); // Save initial state when component mounts
  }, []);

  const handleOnChange = (selected) => {
    setSelectedOption(selected);
    setItems2([]);
    setCategoryName("");
    setCategoryname("");
    setSortOrder(null);
    setCategorystate(false);
    setCategorynameErrorMessage("");

    // Only call API if different from active tab
    const activeTabKey = mapToApiKey(props.activeTab);
    if (selected?.originalKey && selected.originalKey !== activeTabKey) {
      if (selected.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
        dispatch(getConfigJiraIssueTypeList());
      } else if (selected.originalKey === CATEGORY_TYPES.PRIORITY) {
        dispatch(getConfigJiraPriorityList());
      } else if (selected.originalKey === CATEGORY_TYPES.STATUS) {
        dispatch(getConfigJiraStatusList());
      }
    }
  };
  const handleInputOnChange = (value) => {
    if (value.startsWith(" ")) {
      return;
    }
    // if (value.endsWith(" ")) {
    //     value = value.trimEnd();
    // }
    value = value.replace(/\s+/g, " ");
    setCategoryname(value);
    setCategorystate(false);
    setCategoryName(value);
  };
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;

    // Same list reordering
    if (source.droppableId === destination.droppableId) {
      const list =
        source.droppableId === "droppable-1" ? [...items1] : [...items2];
      const [moved] = list.splice(source.index, 1);
      list.splice(destination.index, 0, moved);

      source.droppableId === "droppable-1" ? setItems1(list) : setItems2(list);
    }
    // Moving between lists
    else {
      const sourceList =
        source.droppableId === "droppable-1" ? [...items1] : [...items2];
      const destList =
        destination.droppableId === "droppable-1" ? [...items1] : [...items2];

      const [moved] = sourceList.splice(source.index, 1);
      destList.splice(destination.index, 0, moved);

      if (source.droppableId === "droppable-1") {
        setItems1(sourceList);
        setItems2(destList);
      } else {
        setItems1(destList);
        setItems2(sourceList);
      }
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const categorizedLimitCheck = () => {
    const activeField = selectedOption.originalKey.toLowerCase();
    if (!activeField) {
      return false;
    }

    const dataArray = apidata[selectedOption.originalKey] || [];

    // Get all categorized items (excluding Uncategorized)
    const categorized = Array.isArray(dataArray)
      ? dataArray.filter(
          (item) => item?.categoryName?.trim().toLowerCase() !== CATEGORY_TYPES.UNCATEGORIZED.toLowerCase()
        )
      : [];

    // Check if category name already exists
    const categoryExists = categorized.some(
      (item) =>
        item?.categoryName?.trim().toLowerCase() ===
        Categoryname.trim().toLowerCase()
    );

    // Set limits based on field type
    const limitMap = {
      issuetype: 10,
      status: 19,
      priority: 9,
    };

    const limit = limitMap[activeField] || 10;

    if (!categoryExists && categorized.length >= limit) {
      callCommonAlert(
        "error",
        `Cannot add more than ${limit} categories in ${selectedOption.originalKey}`
      );
      hideCommonAlert();
      return false;
    }

    return true;
  };

  const getTrimmedCategoryname = (name) => {
    if (!name) {
      return "";
    }
    return name.replace(/\s+/g, " ").trimEnd();
  };

  const handlesaveclick = () => {
    // if (!categorizedLimitCheck()) return;

    if (Categoryname.trim() === "") {
      setCategorynameErrorMessage("Category Name cannot be empty");
      setCategorystate(true);
      return;
    }

    if (selectedOption.label.trim() === "") {
      setselectedOptionErrorMessage("selected Option cannot be empty");
      setselectedOptionstate(true);
      return;
    }

    if (Categoryname.trim() !== "") {
      const selectedKey = selectedOption?.originalKey;
      const trimmedCategoryName = getTrimmedCategoryname(Categoryname);

      // Check if category name already exists
      const categoryData = apidata[selectedKey] || [];
      const existingCategory = Array.isArray(categoryData)
        ? categoryData.find(
            (cat) =>
              cat?.categoryName?.toLowerCase() ===
                trimmedCategoryName.toLowerCase() &&
              cat?.categoryName !== CATEGORY_TYPES.UNCATEGORIZED
          )
        : null;

      const configId = existingCategory?.configId || 0;

      // Build payload
      let payload;
      let saveApiCall;
      let itemIds;

      if (selectedKey === CATEGORY_TYPES.ISSUE_TYPE) {
        itemIds = items2
          .map((i) => i.content?.issueTypeId)
          .filter((id) => id != null);
        payload = {
          configId: configId,
          priority: sortOrder,
          categoryName: trimmedCategoryName,
          issueTypeIds: itemIds,
        };
        saveApiCall = dispatch(getJiraIssueTypeSave(payload));
      } else if (selectedKey === CATEGORY_TYPES.PRIORITY) {
        itemIds = items2
          .map((i) => i.content?.priorityId)
          .filter((id) => id != null);
        payload = {
          configId: configId,
          priority: sortOrder,
          categoryName: trimmedCategoryName,
          priorityIds: itemIds,
        };
        saveApiCall = dispatch(getJiraPrioritySave(payload));
      } else if (selectedKey === CATEGORY_TYPES.STATUS) {
        itemIds = items2
          .map((i) => i.content?.statusId)
          .filter((id) => id != null);
        payload = {
          configId: configId,
          priority: sortOrder,
          categoryName: trimmedCategoryName,
          statusIds: itemIds,
        };
        saveApiCall = dispatch(getJiraStatusSave(payload));
      }

      saveApiCall.then((data) => {
        if (
          data.payload.statusCodeValue >= 200 &&
          data.payload.statusCodeValue < 300
        ) {
          callCommonAlert(
            "success",
            _.get(data, "payload.body")
              ? data.payload.body
              : "Updated Successfully"
          );

          setTimeout(() => {
            hideCommonAlert();
            props.handleClose();

            // Dispatch refresh based on selected category
            if (selectedKey === CATEGORY_TYPES.ISSUE_TYPE) {
              dispatch(getConfigJiraIssueTypeList());
            } else if (selectedKey === CATEGORY_TYPES.PRIORITY) {
              dispatch(getConfigJiraPriorityList());
            } else if (selectedKey === CATEGORY_TYPES.STATUS) {
              dispatch(getConfigJiraStatusList());
            }
          }, 2000); // 3 seconds
        } else if (data?.payload?.body) {
          callCommonAlert("error", data?.payload?.body);
          hideCommonAlert();
        } else if (data.error) {
          callCommonAlert(
            "error",
            "Error occurred while adding Categorised fields Please try again"
          );
          hideCommonAlert();
        }
      });
    }
  };

  const moveSelectedItems = (fromItems, toItems, setFromItems, setToItems) => {
    if (selectedItems.length === 0) {
      callCommonAlert("error", "Please select items to move.");
      hideCommonAlert();
      return;
    }
    const movingItems = fromItems.filter((item) =>
      selectedItems.includes(item.id)
    );
    setMovedItems((prev) => [...prev, ...movingItems]); // Track moved items

    const remainingItems = fromItems.filter(
      (item) => !selectedItems.includes(item.id)
    );
    setFromItems(remainingItems);
    setToItems([...toItems, ...movingItems]);
    setSelectedItems([]); // Clear selection
  };

  const handleSearch1 = (e) => setSearchQuery1(e.target.value);
  const handleSearch2 = (e) => setSearchQuery2(e.target.value);

  return (
    <>
      {jiraLoading ? (
        <Spinners />
      ) : (
        <>
          <h6>Add Group </h6>
          <br />
          {/* <h4 className="Noborder">See results in your view based on the filters you select here.</h4>
                    <br /> */}

          <DragDropContext onDragEnd={onDragEnd}>
            <div className="container">
              <Row className="mx-3 mt-3">
                <Col md={5}>
                  <h5 className="Noborder">Select Category</h5>
                  <CustomSelectDropDown
                    options={extractedOptions}
                    onChange={handleOnChange}
                    value={selectedOption}
                    containerClassName="custom-input-field"
                    error={selectedOptionstate}
                    errorMessage={selectedOptionerrorMessage}
                  />
                </Col>

                <Col md={2}></Col>

                <Col md={5}>
                  <Row>
                    <Col md={7}>
                      <h5 className="Noborder">Group Name</h5>
                      <Input
                        type="text"
                        name="Category"
                        placeholder="Enter Group Name"
                        containerClassName="frmgroup default-input w-100"
                        onChange={(e) => handleInputOnChange(e.target.value)}
                        autoComplete="off"
                        min={2}
                        maxLength="100"
                        inputClassName="InputStyle"
                        error={Categorystate}
                        errorMessage={CategorynameerrorMessage}
                        value={categoryName}
                      />
                    </Col>

                    <Col md={5}>
                      <h5 className="Noborder">Sort Order</h5>

                      <CustomSelectDropDown
                        noOptionSorting={true}
                        options={getSortOrderOptions}
                        onChange={(selected) => {
                          // Store selected value directly in state
                          const selectedOrder = selected?.value || null;
                          setSortOrder(selectedOrder);
                        }}
                        value={
                          getSortOrderOptions.find(
                            (opt) => opt.value === sortOrder
                          ) || null
                        }
                        placeholder="Select Order"
                        containerClassName="custom-input-field"
                        disabled={!categoryName.trim()}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className="mx-3 mt-3">
                {/* Uncategorised Items */}
                <Col md={5}>
                  <h5 className="Noborder">Unmapped</h5>
                  <div className="boxStyle">
                    <div className="searchBoxStyle">
                      <input
                        type="text"
                        placeholder="Search"
                        className="inputStyle"
                        onChange={handleSearch1}
                      />
                    </div>
                    <Droppable
                      droppableId="droppable-1"
                      isDropDisabled={!categoryName.trim()}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="listStyle dropAdjust"
                        >
                          {items1
                            .filter((item) => {
                              const itemName =
                                item.content?.name || item.content || "";
                              return itemName
                                .toLowerCase()
                                .includes(searchQuery1.toLowerCase());
                            })
                            .map((item, index) => (
                              <Draggable
                                key={item.id}
                                draggableId={item.id}
                                index={index}
                                isDropDisabled={!categoryName.trim()}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    className={`${
                                      !categoryName.trim()
                                        ? "disabled-container"
                                        : "listStyle dragging"
                                    }`}
                                  >
                                    <input
                                      type="checkbox"
                                      isDropDisabled={!categoryName.trim()}
                                      checked={selectedItems.includes(item.id)}
                                      onChange={() =>
                                        handleCheckboxChange(item.id)
                                      }
                                    />{" "}
                                    {item.content?.name || item.content}
                                  </div>
                                )}
                              </Draggable>
                            ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </div>
                </Col>

                {/* Arrows for Moving Items */}
                <Col
                  md={2}
                  className="arrowContainer"
                  style={{ gap: "1px", minHeight: "350px", display: "flex" }}
                >
                  <Button
                    variant="light"
                    className="arrowButtonStyle"
                    onClick={() =>
                      moveSelectedItems(items1, items2, setItems1, setItems2)
                    }
                    disabled={!categoryName.trim()}
                  >
                    →
                  </Button>
                  <Button
                    variant="light"
                    className="arrowButtonStyle"
                    onClick={() =>
                      moveSelectedItems(items2, items1, setItems2, setItems1)
                    }
                    disabled={!categoryName.trim()}
                  >
                    ←
                  </Button>
                </Col>

                {/* Categorised Items */}
                <Col md={5}>
                  <h5 className="Noborder">
                    Mapped {categoryName && ` - ${categoryName}`}
                  </h5>
                  <div className="boxStyle">
                    <div className="searchBoxStyle">
                      <input
                        type="text"
                        placeholder="Search"
                        className="inputStyle"
                        onChange={handleSearch2}
                      />
                    </div>
                    <Droppable droppableId="droppable-2">
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="listStyle dropAdjust"
                          style={{
                            minHeight: "100px",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {items2.length === 0 && (
                            <div
                              className="empty-placeholder"
                              style={{
                                padding: "20px",
                                textAlign: "center",
                                color: "#aaa",
                              }}
                            >
                              {/* Drag items here */}
                            </div>
                          )}
                          {items2
                            .filter((item) => {
                              const itemName =
                                item.content?.name || item.content || "";
                              return itemName
                                .toLowerCase()
                                .includes(searchQuery2.toLowerCase());
                            })
                            .map((item, index) => (
                              <Draggable
                                key={item.id}
                                draggableId={item.id}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    className={`item ${
                                      snapshot.isDragging ? "dragging" : ""
                                    }`}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedItems.includes(item.id)}
                                      onChange={() =>
                                        handleCheckboxChange(item.id)
                                      }
                                    />{" "}
                                    {item.content?.name || item.content}
                                  </div>
                                )}
                              </Draggable>
                            ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </div>
                </Col>
              </Row>
            </div>
          </DragDropContext>

          <div
            className="btnswrap d-flex justify-content-end"
            style={{ gap: "5px" }}
          >
            <ButtonComponent
              text="Cancel"
              className={"cancelBtnStyle btn btn-primary"}
              onClick={props.handleClose}
            />
            <ButtonComponent
              text="Save"
              className={"btnStyle btn btn-primary"}
              onClick={handlesaveclick}
              disabled={!isFormValid || jiraLoading}
            />{" "}
          </div>
        </>
      )}
    </>
  );
};

AddConfig.propTypes = {
  ApiData: PropTypes.shape({
    Status: PropTypes.arrayOf(
      PropTypes.shape({
        configId: PropTypes.number,
        categoryName: PropTypes.string,
        priorityOrder: PropTypes.number,
        configurationtype: PropTypes.string,
        statusType: PropTypes.arrayOf(
          PropTypes.shape({
            statusId: PropTypes.number,
            name: PropTypes.string,
          })
        ),
      })
    ),
    IssueType: PropTypes.arrayOf(
      PropTypes.shape({
        configId: PropTypes.number,
        categoryName: PropTypes.string,
        priorityOrder: PropTypes.number,
        configurationtype: PropTypes.string,
        issueTypes: PropTypes.arrayOf(
          PropTypes.shape({
            issueTypeId: PropTypes.number,
            name: PropTypes.string,
          })
        ),
      })
    ),
    Priority: PropTypes.arrayOf(
      PropTypes.shape({
        configId: PropTypes.number,
        categoryName: PropTypes.string,
        priorityOrder: PropTypes.number,
        configurationtype: PropTypes.string,
        priorityType: PropTypes.arrayOf(
          PropTypes.shape({
            priorityId: PropTypes.number,
            name: PropTypes.string,
          })
        ),
      })
    ),
  }).isRequired,
  activeTab: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AddConfig;
